import { Component, OnInit } from "@angular/core";
import { resendOtpEndPoient } from "src/app/Data/service/global.service";
import { AuthService } from "../service/auth.service";
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from "@angular/router";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { LoadingBarService } from "@ngx-loading-bar/core";
const Swal = require('sweetalert2')
import { israelPhoneNumberValidator } from './../../validators/israelPhoneNumberValidator';

@Component({
  selector: "app-resendotp",
  templateUrl: "./resendotp.component.html",
  styleUrls: ["./resendotp.component.scss"]
})

export class ResendotpComponent implements OnInit {
  
  public show: boolean = false;
  error:string = '';
  userRegistId :any;
  otpCode: number;
  userLanguage:string;
  userForgetPassword:any;
  resendForm = new FormGroup({
    'phone_number': new FormControl('', [Validators.required, israelPhoneNumberValidator(7, 10)]),
  });
  constructor( private authService:AuthService ,
    private spinner: NgxSpinnerService , 
    private Router:Router,
    private loader: LoadingBarService
    ) { 

  }

  private getLocalizedMsg(res: any): string {
    if (this.userLanguage === 'ar' && res?.messageAr) return res.messageAr;
    if (this.userLanguage === 'he' && res?.messageHe) return res.messageHe;
    return res?.messageEn || res?.message || '';
  }

  submitResendForm(RegisterForm: FormGroup) {
    let customerPhone = this.resendForm.value.phone_number;
    if (customerPhone.startsWith('0')) {
      customerPhone = customerPhone.substring(1);
    }

    let model = {
      phone_number: '+972' + customerPhone,
    };
    this.spinner.show();

    this.authService.resendOtp(resendOtpEndPoient.POST, model).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status === 200) {
          Swal.fire({
            icon: 'success',
            title: this.getLocalizedMsg(res),
            confirmButtonColor: '#141414',
          });
          this.userForgetPassword = res.userId;
          localStorage.setItem('userForgetPassword', this.userForgetPassword);
          this.Router.navigate(['/forgot-password']);
        } else {
          Swal.fire({
            icon: 'error',
            title: this.getLocalizedMsg(res),
            confirmButtonColor: '#141414',
          });
        }
      },
      error: (err) => {
        this.spinner.hide();
        const body = err?.error || {};
        Swal.fire({
          icon: 'error',
          title: this.getLocalizedMsg(body) || 'Something went wrong',
          confirmButtonColor: '#141414',
        });
      }
    });
  };

  

  ngOnInit() {
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 1000);

    this.userRegistId = JSON.parse(localStorage.getItem('user_id'));
    this.userLanguage = localStorage.getItem('curentLang');

  } 
}
